import React, { useState, useEffect, useRef } from 'react';
import { useNavigate } from 'react-router-dom';
import './UserManagement.css';
import api from '../../api/axios.js'
import { FiEye, FiEdit, FiTrash2, FiSearch, FiUsers } from "react-icons/fi";
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { useDebouncedValue } from '../../hooks/useDebouncedValue';


const UserManagement = () => {
  const navigate = useNavigate();
  const customerModalRef = useRef(null);
  const vendorModalRef = useRef(null);
  const advisorModalRef = useRef(null);
  const influencerModalRef = useRef(null);
  const [activeTab, setActiveTab] = useState('vendor');
  const [searchTerm, setSearchTerm] = useState('');
  const debouncedSearch = useDebouncedValue(searchTerm);
  const [totalPages, setTotalPages] = useState(1)
  const [vendors, setVendors] = useState([]);
  const [customers, setCustomers] = useState([]);
  const [advisors, setAdvisors] = useState([]);
  const [influencers, setInfluencers] = useState([]);
  const [loading, setLoading] = useState(false);
  const [pagination, setPagination] = useState({})
  const [createUserError, setCreateUserError] = useState('')
  const [formErrors, setFormErrors] = useState({});

  const [page, setPage] = useState(1);
  const limit = 10;


  // 🔹 CHANGED: filters state (logic only)
  const [filters, setFilters] = useState({
    priority: "",
    status: "",
    kycVerified: "",
    state: "",
    district: "",
    userType:"vendor",
    isClaimed: "",
  });

  const [showAddCustomerModal, setShowAddCustomerModal] = useState(false);
  const [showAddVendorModal, setShowAddVendorModal] = useState(false);
  const [showAddAdvisorModal, setShowAddAdvisorModal] = useState(false);
  const [showAddInfluencerModal, setShowAddInfluencerModal] = useState(false);
  const [customerForm, setCustomerForm] = useState({
    name: '',
    email: '',
    mobile_number: '',
    password: ''
  });

  const [vendorForm, setVendorForm] = useState({
    name: '',
    email: '',
    mobile_number: '',
    password: ''
  });

  const [AdvisorForm, setAdvisorForm] = useState({
    name: '',
    email: '',
    mobile_number: '',
    password: '',
    userType: 'Select Advisor'
  });

  const [influencerForm, setInfluencerForm] = useState({
    name: '',
    email: '',
    mobile_number: '',
    password: ''
  });


  const initialCustomerForm = {
    name: "",
    email: "",
    mobile_number: "",
    password: "",
  };

  const initialVendorForm = {
    name: "",
    email: "",
    mobile_number: "",
    password: "",
  };

  const initialAdvisorForm = {
    name: "",
    email: "",
    mobile_number: "",
    password: "",
    userType: ""
  };

  const initialInfluencerForm = {
    name: "",
    email: "",
    mobile_number: "",
    password: "",
  };


  // ✅ MOVE THIS UP (before handleCreateUser)
  // const validateUserForm = (form, isUpdate = false) => {
  //   const errors = {};

  //   if (!form.name?.trim()) errors.name = "Name is required";

  //   if (!form.email?.trim()) {
  //     errors.email = "Email is required";
  //   } else if (!/\S+@\S+\.\S+/.test(form.email)) {
  //     errors.email = "Invalid email format";
  //   }

  //   if (!form.mobile_number?.trim()) {
  //     errors.mobile_number = "Mobile number is required";
  //   } else if (!/^\d{10}$/.test(form.mobile_number)) {
  //     errors.mobile_number = "Mobile number must be 10 digits";
  //   }

  //   // 🔹 UPDATE me password optional
  //   if (!isUpdate && !form.password?.trim()) {
  //     errors.password = "Password is required";
  //   }

  //   return errors;
  // };

const validateUserForm = (form, isUpdate = false, original = {}) => {
  const errors = {};

  const name = form.name?.trim();
  const email = form.email?.trim().toLowerCase();
  const mobile = form.mobile_number?.trim();
  const password = form.password?.trim();

  const nameRegex = /^[A-Za-z ]{2,60}$/;
  const emailRegex =
    /^[a-z0-9._%+-]+@[a-z0-9.-]+\.[a-z]{2,}$/;

  // Exactly 10 digits
  const mobileRegex = /^\d{10}$/;

  // CREATE MODE
  if (!isUpdate) {
    // Name
    if (!name) {
      errors.name = "Name is required";
    } else if (!nameRegex.test(name)) {
      errors.name =
        "Name must contain only letters and spaces (2-60 characters)";
    }

    // Email
    if (!email) {
      errors.email = "Email is required";
    } else if (email.length > 60) {
      errors.email = "Email cannot exceed 60 characters";
    } else if (!emailRegex.test(email)) {
      errors.email = "Invalid email format";
    }

    // Mobile
    if (!mobile) {
      errors.mobile_number = "Mobile number is required";
    } else if (!mobileRegex.test(mobile)) {
      errors.mobile_number =
        "Mobile number must contain exactly 10 digits";
    }

    // Password
    if (!password) {
      errors.password = "Password is required";
    } else if (password.length < 2) {
      errors.password =
        "Password must be at least 2 characters";
    } else if (password.length > 8) {
      errors.password =
        "Password cannot exceed 8 characters";
    }

    // Advisor validation
    if (
      form.userType !== undefined &&
      (!form.userType?.trim() ||
        form.userType === "Select Advisor")
    ) {
      errors.userType = "Advisor type is required";
    }

    return errors;
  }

  // UPDATE MODE

  if (form.name !== original.name) {
    if (!name) {
      errors.name = "Name is required";
    } else if (!nameRegex.test(name)) {
      errors.name =
        "Name must contain only letters and spaces (2-60 characters)";
    }
  }

  if (form.email !== original.email) {
    if (!email) {
      errors.email = "Email is required";
    } else if (!emailRegex.test(email)) {
      errors.email = "Invalid email format";
    }
  }

  if (form.mobile_number !== original.mobile_number) {
    if (!mobile) {
      errors.mobile_number = "Mobile number is required";
    } else if (!mobileRegex.test(mobile)) {
      errors.mobile_number =
        "Mobile number must contain exactly 10 digits";
    }
  }

  return errors;
};



  useEffect(() => {
    const handleClickOutside = (e) => {
      setCreateUserError('')
      if (
        showAddCustomerModal &&
        customerModalRef.current &&
        !customerModalRef.current.contains(e.target)
      ) {
        setShowAddCustomerModal(false);
      }

      if (
        showAddVendorModal &&
        vendorModalRef.current &&
        !vendorModalRef.current.contains(e.target)
      ) {
        setShowAddVendorModal(false);
      }

      if (
        showAddAdvisorModal &&
        advisorModalRef.current &&
        !advisorModalRef.current.contains(e.target)
      ) {
        setShowAddAdvisorModal(false);
      }

      if (
        showAddInfluencerModal &&
        influencerModalRef.current &&
        !influencerModalRef.current.contains(e.target)
      ) {
        setShowAddInfluencerModal(false);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, [showAddCustomerModal, showAddVendorModal, showAddAdvisorModal, showAddInfluencerModal]);

  const [showDropdown, setShowDropdown] = useState(null);
  const [totalCustomers, setTotalCustomers] = useState(0)
  const [totalVendors, setTotalVendors] = useState(0)
  const [totalAdvisors, setTotalAdvisors] = useState(0)
  const [totalInfluencers, setTotalInfluencers] = useState(0)
  const [tabTotal, setTabTotal] = useState(0)
  const [showEditModal, setShowEditModal] = useState(false);
  const [selectedItem, setSelectedItem] = useState(null);
  const [editForm, setEditForm] = useState({});
  const [showDeleteModal, setShowDeleteModal] = useState(false);
  const [deleteItem, setDeleteItem] = useState(null);


  const handleCreateUser = async (payload) => {
    const errors = validateUserForm(payload, false); // ✅ create mode

    if (Object.keys(errors).length > 0) {
      setFormErrors(errors);
      return false;
    }
    try {
      await api.post("/admin/create/user", payload);
      toast.success(
        `${payload.userType === 'vendor' ? 'Vendor' : payload.userType === 'customer' ? 'Customer' : payload.userType === 'influencer' ? 'Influencer' : 'Advisor'} created successfully!`
      );
      setFormErrors({});
      fetchUsers(1);
      return true;
    } catch (err) {


      toast.error(err?.response?.data?.message || err.message);
      console.error(err);
      // if (err?.response?.status === 409) {
      //   setFormErrors({ email: "Email already exists" });
      // }
      return false;
    }
  };






  const resolveUserType = () => {
    if (activeTab === 'advisor') {
      return filters.userType || 'advisor';
    }
    return activeTab;
  };

  const resetListFilters = (tab) => ({
    priority: "",
    status: "",
    kycVerified: "",
    state: "",
    district: "",
    userType: tab === "advisor" ? "advisor" : tab,
    isClaimed: "",
  });

  const handleTabChange = (tab) => {
    setActiveTab(tab);
    setFilters(resetListFilters(tab));
    setSearchTerm("");
  };

  const clearListFilters = () => {
    setFilters(resetListFilters(activeTab));
    setSearchTerm("");
  };

  const fetchUsers = async (pageNo = 1) => {
    try {
      setLoading(true);

      const params = {
        userType: resolveUserType(),
        page: pageNo,
        limit,
      };

      if (filters.status) params.status = filters.status;
      if (filters.kycVerified) params.kycVerified = filters.kycVerified;
      if (filters.isClaimed) params.isClaimed = filters.isClaimed;
      if (filters.state) params.state = filters.state;
      if (filters.district) params.district = filters.district;
      if (debouncedSearch.trim()) params.search = debouncedSearch.trim();

      const res = await api.get("/admin/all-users", { params });

      if (activeTab === "vendor") {
        setVendors(res.data.data);
      } else if (activeTab === "customer") {
        setCustomers(res.data.data);
      } else if (activeTab === "influencer") {
        setInfluencers(res.data.data);
      } else {
        setAdvisors(res.data.data);
      }

      setTotalPages(res.data?.pagination?.totalPages);
      setTotalCustomers(res.data?.totalCustomers);
      setTotalVendors(res.data?.totalVendors);
      setTotalAdvisors(res.data?.totalAdvisors);
      setTotalInfluencers(res.data?.totalInfluencers || 0);
      setTabTotal(res.data?.tabTotal ?? 0);
      setPagination(res.data.pagination);
      setPage(res.data.pagination.page);
    } catch (error) {
      console.error("Fetch users error:", error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchUsers(1);
  }, [activeTab, filters, debouncedSearch]);

  const handleNextPage = () => {
    if (pagination.page < pagination.totalPages) {
      fetchUsers(pagination.page + 1);
    }
  };

  const handlePrevPage = () => {
    if (pagination.page > 1) {
      fetchUsers(pagination.page - 1);
    }
  };

  const handleExportUsers = async () => {
    try {
      const exportUserType =
        activeTab === "advisor" ? (filters.userType || "advisor") : activeTab;

      const response = await api.get("/admin/all-users/export-csv", {
        params: {
          userType: exportUserType,
          status: filters.status || "",
          search: debouncedSearch.trim() || "",
        },
        responseType: "blob",
      });

      const url = window.URL.createObjectURL(new Blob([response.data]));
      const link = document.createElement("a");
      link.href = url;
      link.setAttribute("download", `${exportUserType}_${Date.now()}.csv`);
      document.body.appendChild(link);
      link.click();
      link.remove();
      window.URL.revokeObjectURL(url);
      toast.success("CSV exported successfully");
    } catch (error) {
      console.error("CSV export failed", error);
      toast.error("Failed to export CSV");
    }
  };

  const tableData =
    activeTab === "vendor"
      ? vendors
      : activeTab === "customer"
      ? customers
      : activeTab === "influencer"
      ? influencers
      : advisors;

  const TAB_LABELS = {
    vendor: "vendors",
    customer: "customers",
    advisor: "advisors",
    influencer: "influencers",
  };

  const platformTotal =
    totalVendors + totalCustomers + totalAdvisors + totalInfluencers;
  const tabLabel = TAB_LABELS[activeTab] || "users";
  const filteredTotal = pagination.totalRecords ?? 0;
  const currentPage = pagination.page ?? 1;
  const rangeStart =
    filteredTotal === 0 ? 0 : (currentPage - 1) * limit + 1;
  const rangeEnd = Math.min(currentPage * limit, filteredTotal);
  const hasActiveFilters = Boolean(
    debouncedSearch.trim() ||
      filters.status ||
      filters.kycVerified ||
      filters.state ||
      filters.district
  );
  const isFilteredView = hasActiveFilters;

  const activeFilterLabels = [
    debouncedSearch.trim() && `Search: "${debouncedSearch.trim()}"`,
    filters.status && `Status: ${filters.status}`,
    filters.kycVerified && `KYC: ${filters.kycVerified === "true" ? "Verified" : "Not verified"}`,
    filters.isClaimed && `Claim: ${filters.isClaimed === "true" ? "Claimed (Verified)" : "Unclaimed"}`,
    filters.state && `State: ${filters.state}`,
    filters.district && `District: ${filters.district}`,
    activeTab === "advisor" &&
      filters.userType &&
      filters.userType !== "advisor" &&
      `Role: ${filters.userType.replace("advisor-", "").replace(/-/g, " ")}`,
  ].filter(Boolean);

  return (
    <div className="user-management">
      <div className="user-management-header">
        <h1>User Management</h1>
      </div>

      <div className="stats-section">
        <div className="stats-section-header">
          <h2>Platform Overview</h2>
          <p>
            Overall totals for each user type. The list below may show fewer results when
            search or filters are applied.
          </p>
        </div>

        <div className="stats-cards">
          <div className="stat-card">
            <div className="stat-info">
              <span className="stat-label">All Users</span>
              <span className="stat-value">{platformTotal}</span>
              <span className="stat-hint">Vendors + Customers + Advisors + Influencers</span>
            </div>
            <div className="stat-icon leads"><FiUsers /></div>
          </div>

          <div className={`stat-card ${activeTab === "vendor" ? "stat-card-active" : ""}`}>
            <div className="stat-info">
              <span className="stat-label">Vendors</span>
              <span className="stat-value">{totalVendors}</span>
              <span className="stat-hint">Active accounts only</span>
            </div>
            <div className="stat-icon leads"><FiUsers /></div>
          </div>

          <div className={`stat-card ${activeTab === "customer" ? "stat-card-active" : ""}`}>
            <div className="stat-info">
              <span className="stat-label">Customers</span>
              <span className="stat-value">{totalCustomers}</span>
              <span className="stat-hint">Active accounts only</span>
            </div>
            <div className="stat-icon leads"><FiUsers /></div>
          </div>

          <div className={`stat-card ${activeTab === "advisor" ? "stat-card-active" : ""}`}>
            <div className="stat-info">
              <span className="stat-label">Advisors</span>
              <span className="stat-value">{totalAdvisors}</span>
              <span className="stat-hint">Active accounts only</span>
            </div>
            <div className="stat-icon leads"><FiUsers /></div>
          </div>

          <div className={`stat-card ${activeTab === "influencer" ? "stat-card-active" : ""}`}>
            <div className="stat-info">
              <span className="stat-label">Influencers</span>
              <span className="stat-value">{totalInfluencers}</span>
              <span className="stat-hint">Active accounts only</span>
            </div>
            <div className="stat-icon leads"><FiUsers /></div>
          </div>
        </div>
      </div>

      <div className="tab-buttons">
        <button
          className={`tab-btn ${activeTab === 'vendor' ? 'active' : ''}`}
          onClick={() => handleTabChange('vendor')}
        >
          Vendor
        </button>
        <button
          className={`tab-btn ${activeTab === 'customer' ? 'active' : ''}`}
          onClick={() => handleTabChange('customer')}
        >
          Customer
        </button>
        <button
          className={`tab-btn ${activeTab === 'advisor' ? 'active' : ''}`}
          onClick={() => handleTabChange('advisor')}
        >
          Advisor
        </button>
        <button
          className={`tab-btn ${activeTab === 'influencer' ? 'active' : ''}`}
          onClick={() => handleTabChange('influencer')}
        >
          Influencer
        </button>
      </div>

      <div className="table-section">
        <div className="table-header">
          <div className="table-title-group">
            <h3>
              {activeTab === "vendor"
                ? "Vendor List"
                : activeTab === "customer"
                ? "Customer List"
                : activeTab === "influencer"
                ? "Influencer List"
                : "Advisor List"}
            </h3>
            <p className="table-subtitle">
              {loading
                ? "Loading..."
                : filteredTotal === 0
                ? `No ${tabLabel} found${
                    hasActiveFilters ? " matching your search or filters" : ""
                  }`
                : (
                  <>
                    Showing <strong>{rangeStart}–{rangeEnd}</strong> of{" "}
                    <strong>{filteredTotal}</strong> {tabLabel}
                    {isFilteredView && (
                      <span className="filtered-note">
                        {" "}
                        (filtered from {tabTotal} total {tabLabel})
                      </span>
                    )}
                  </>
                )}
            </p>
          </div>

          <div className="table-actions">
            <div className="search-box">
              <input
                type="text"
                placeholder={`Search all ${tabLabel}...`}
                value={searchTerm}
                onChange={(e) => setSearchTerm(e.target.value)}
              />
              <span className="search-icon"><FiSearch /></span>
            </div>

            {/* 🔹 CHANGED: filter logic only */}
            {/* <button className="filter-btn" onClick={applyFilters}>⚙️</button> */}

            <button
              className="add-btn"
              onClick={handleExportUsers}
            >
              Export CSV
            </button>

            <button
              className="add-btn"
              onClick={() => {
                setFormErrors({})

                if (activeTab === 'vendor') {
                  setShowAddVendorModal(true);
                } else if (activeTab === 'customer') {
                  setShowAddCustomerModal(true);
                }
                else if (activeTab === 'influencer') {
                  setShowAddInfluencerModal(true);
                }
                else {
                  setShowAddAdvisorModal(true)
                }
              }}

            >
              {activeTab === 'vendor' ? 'Add Vendor' : activeTab === 'customer' ? 'Add Customer' : activeTab === 'influencer' ? 'Add Influencer' : 'Add Advisor'}
            </button>
          </div>
        </div>


        <div className="table-filters">
          <select
            value={filters.status}
            onChange={(e) =>
              setFilters((prev) => ({ ...prev, status: e.target.value }))
            }
          >
            <option value="">All Status</option>
            <option value="active">Active</option>
            <option value="inactive">Inactive</option>
          </select>

          {activeTab === 'vendor' && (
            <select
              value={filters.isClaimed || ''}
              onChange={(e) =>
                setFilters((prev) => ({ ...prev, isClaimed: e.target.value }))
              }
            >
              <option value="">All Profiles</option>
              <option value="true">✅ Claimed Profiles (OTP Verified)</option>
              <option value="false">Unclaimed / Regular Profiles</option>
            </select>
          )}

          {activeTab === 'advisor' &&
            <select
              value={filters.userType}
              onChange={(e) => setFilters({ ...filters, userType: e.target.value })}
            >
              <option value="advisor">All Advisors</option>
              <option value="advisor-district-coordinator">District Coordinator</option>
              <option value="advisor-commisionerate">Commisionery Manager</option>
              <option value="advisor-state-head">State Head</option>
            </select>
          }

          {hasActiveFilters && (
            <button type="button" className="clear-filters-btn" onClick={clearListFilters}>
              Clear filters
            </button>
          )}
        </div>

        {activeFilterLabels.length > 0 && (
          <div className="active-filters">
            <span className="active-filters-label">Active filters:</span>
            {activeFilterLabels.map((label) => (
              <span key={label} className="filter-chip">{label}</span>
            ))}
          </div>
        )}



        <div className="data-table">
          {loading ? (
            <div className="loading-container">
              <div className="loading-spinner"></div>
              <p>Loading users...</p>
            </div>
          ) : (
            <table>
              <thead>
                <tr>
                  <th>{activeTab === 'vendor' ? 'Vendor Name' : activeTab === 'customer' ? 'Customer Name' : activeTab === 'influencer' ? 'Influencer Name' : 'Advisor Name'}</th>
                  <th>Email</th>
                  <th>Phone Number</th>
                  <th>Joining Date</th>
                   <th>Status</th>
                  <th>Action</th>
                </tr>
              </thead>

              <tbody>
                {tableData.length === 0 ? (
                  <tr>
                    <td colSpan="6" className="no-data">
                      {loading ? 'Loading...' : 'No users found'}
                    </td>
                  </tr>
                ) : (
                tableData.map((item, index) => (
                  <tr key={item._id} className="table-row-animated" style={{ animationDelay: `${index * 0.1}s` }}>
                  <td>
                    <div>
                      <strong>
                        {item.name
                          ? item.name.charAt(0).toUpperCase() + item.name.slice(1)
                          : 'N/A'}
                      </strong>
                      {item.shop_name && (
                        <div style={{ fontSize: '12px', color: '#64748b' }}>
                          {item.shop_name}
                        </div>
                      )}
                      {activeTab === 'vendor' && item.isClaimed && (
                        <div>
                          <span
                            style={{
                              display: 'inline-block',
                              fontSize: '10.5px',
                              background: '#dcfce7',
                              color: '#15803d',
                              padding: '1px 6px',
                              borderRadius: '4px',
                              fontWeight: 700,
                              marginTop: '2px',
                            }}
                          >
                            ✓ Claimed Profile (OTP Verified)
                          </span>
                        </div>
                      )}
                      {activeTab === 'vendor' && !item.isClaimed && item.isImported && (
                        <div>
                          <span
                            style={{
                              display: 'inline-block',
                              fontSize: '10.5px',
                              background: '#fef3c7',
                              color: '#b45309',
                              padding: '1px 6px',
                              borderRadius: '4px',
                              fontWeight: 600,
                              marginTop: '2px',
                            }}
                          >
                            Imported
                          </span>
                        </div>
                      )}
                    </div>
                  </td>

<td>
  {item.email?.trim() || 'N/A'}
</td>

<td>
  {item.mobile_number?.trim() || 'N/A'}
</td>

<td>
  {item.date_of_joining
    ? new Date(item.date_of_joining).toLocaleDateString('en-IN')
    : 'N/A'}
</td>
<td>
        <span className={`status-badge ${item.status}`}>
          {item.status ? item.status.charAt(0).toUpperCase() + item.status.slice(1) : 'N/A'}
        </span>
      </td>
      
                    <td>
                      <div className="action-icons">
                        <button
                          className="icon-btn view fieye"
                          onClick={() =>
                            navigate(
                              activeTab === 'vendor'
                                ? `/vendor-details/${item._id}`
                                : activeTab === 'customer'
                                ? `/customer-details/${item._id}`
                                : activeTab === 'influencer'
                                ? `/influencer-details/${item._id}`
                                : `/agent-management/${item._id}`
                            )
                          }
                        >
                          <FiEye />
                        </button>

                        <button
                          className="icon-btn edit fiedit"
                          onClick={() => {
                            setFormErrors({});
                            setSelectedItem(item);
                            setEditForm(item);
                            setShowEditModal(true);
                          }}
                        >
                          <FiEdit />
                        </button>

                        {/* <button
                          className="icon-btn delete fitrash"
                          onClick={() => {
                            setDeleteItem(item);      // save item to delete
                            setShowDeleteModal(true); // open modal
                          }}
                        >
                          <FiTrash2 />
                        </button> */}
                        <button
                          className="icon-btn delete fitrash"
                          onClick={() => {
                            setDeleteItem(item);
                            setShowDeleteModal(true);
                          }}
                        >
                          <FiTrash2 />
                        </button>

                      </div>
                    </td>
                  </tr>
                )))}
              </tbody>
            </table>
          )}

        </div>

          {/* Pagination UI */}
          <div className="table-footer">
            {!loading && (
              <p className="results-summary">
                {filteredTotal === 0
                  ? `No ${tabLabel} to display`
                  : `Page ${currentPage} of ${pagination.totalPages || 1} · ${filteredTotal} ${tabLabel} in current view`}
              </p>
            )}

            {pagination.totalPages > 1 && (
            <div className="pagination">
              <button
                onClick={handlePrevPage}
                className={page === 1 ? "pagination-disabled" : "pag-nxt-btn"}
                disabled={pagination.page === 1}
              >
                Prev
              </button>

              <span>
                Page {pagination.page} of {pagination.totalPages}
              </span>

              <button
                onClick={handleNextPage}
                disabled={pagination.page === pagination.totalPages}
                className={
                  page === totalPages
                    ? "pagination-disabled"
                    : "pagination-btn pag-nxt-btn"
                }
              >
                Next
              </button>
            </div>
          )}

        </div>
      </div>


      {/* Add Customer Modal */}
      {showAddCustomerModal && (
        <div className="modal-overlay">
          <div className="modal-content" ref={customerModalRef}>
            <h2>Add Customer</h2>

            <input
              placeholder="Name"
              value={customerForm.name}
             onChange={(e) =>
  setCustomerForm({
    ...customerForm,
    name: e.target.value.slice(0, 60),
  })
}
            />
            {formErrors.name && <span className="form-error">{formErrors.name}</span>}
            <input
              placeholder="Email"
              value={customerForm.email}
onChange={(e) =>
  setCustomerForm({
    ...customerForm,
    email: e.target.value
      .toLowerCase()
      .slice(0, 60),
  })
}
            />
            {formErrors.email && <span className="form-error">{formErrors.email}</span>}
            <input
              placeholder="Mobile"
              value={customerForm.mobile_number}
onChange={(e) =>
  setCustomerForm({
    ...customerForm,
    mobile_number: e.target.value
      .replace(/\D/g, "")
      .slice(0, 10),
  })
}
            />
            {formErrors.mobile_number && (
              <span className="form-error">{formErrors.mobile_number}</span>
            )}
            <input
              type="password"
              placeholder="Password"
              value={customerForm.password}
onChange={(e) =>
  setCustomerForm({
    ...customerForm,
    password: e.target.value.slice(0, 8),
  })
}
            />
            {formErrors.password && (
              <span className="form-error">{formErrors.password}</span>
            )}
            {/* {createUserError && (
              <p className='error-msg'>{createUserError}</p>
            )} */}

            <button
              onClick={async () => {
                const success = await handleCreateUser({
                  ...customerForm,
                  userType: "customer",
                });
                if (success) {
                  setCustomerForm(initialCustomerForm);
                  setShowAddCustomerModal(false)
                }
              }}
            >
              Done
            </button>
          </div>
        </div>
      )}

      {/* Add Vendor Modal */}
      {showAddVendorModal && (
        <div className="modal-overlay">
          <div className="modal-content" ref={vendorModalRef}>
            <h2>Add Vendor</h2>

            <input
              placeholder="Name"
              value={vendorForm.name}
             onChange={(e) =>
  setVendorForm({
    ...vendorForm,
    name: e.target.value
      .replace(/[^A-Za-z ]/g, "")
      .slice(0, 60),
  })
}
            />

            {formErrors.name && (
              <span className="form-error">{formErrors.name}</span>
            )}
            <input
              placeholder="Email"
              value={vendorForm.email}
             onChange={(e) =>
  setVendorForm({
    ...vendorForm,
    email: e.target.value
      .toLowerCase()
      .slice(0, 60),
  })
}
            />
            {formErrors.email && (
              <span className="form-error">{formErrors.email}</span>
            )}
            <input
              placeholder="Mobile"
              value={vendorForm.mobile_number}
             onChange={(e) =>
  setVendorForm({
    ...vendorForm,
    mobile_number: e.target.value
      .replace(/\D/g, "")
     .slice(0, 10),
  })
}
            />

            {formErrors.mobile_number && (
              <span className="form-error">{formErrors.mobile_number}</span>
            )}

            <input
              type="password"
              placeholder="Password"
              value={vendorForm.password}
onChange={(e) =>
  setVendorForm({
    ...vendorForm,
    password: e.target.value.slice(0, 8),
  })
}
            />

            {formErrors.password && (
              <span className="form-error">{formErrors.password}</span>
            )}

            {createUserError && (
              <p className='error-msg'>{createUserError}</p>
            )}

            <button
              onClick={async () => {
                const success = await handleCreateUser({
                  ...vendorForm,
                  userType: "vendor",
                });

                if (success) {
                  setVendorForm(initialVendorForm);
                  setShowAddVendorModal(false)
                }
              }}
            >
              Done
            </button>
          </div>
        </div>
      )}

      {showAddAdvisorModal && (
        <div className="modal-overlay">
          <div className="modal-content" ref={advisorModalRef}>
            <h2>Add Advisor</h2>

            <input
              placeholder="Name"
              value={AdvisorForm.name}
             onChange={(e) =>
  setAdvisorForm({
    ...AdvisorForm,
    name: e.target.value
      .replace(/[^A-Za-z ]/g, "")
      .slice(0, 60),
  })
}
            />

            {formErrors.name && (
              <span className="form-error">{formErrors.name}</span>
            )}
            <input
              placeholder="Email"
              value={AdvisorForm.email}
              onChange={(e) =>
  setAdvisorForm({
    ...AdvisorForm,
    email: e.target.value
      .toLowerCase()
      .slice(0, 60),
  })
}
            />
            {formErrors.email && (
              <span className="form-error">{formErrors.email}</span>
            )}
            <input
              placeholder="Mobile"
              value={AdvisorForm.mobile_number}
              onChange={(e) =>
  setAdvisorForm({
    ...AdvisorForm,
    mobile_number: e.target.value
      .replace(/\D/g, "")
     
      .slice(0, 10),
  })
}
            />

            {formErrors.mobile_number && (
              <span className="form-error">{formErrors.mobile_number}</span>
            )}

            <input
              type="password"
              placeholder="Password"
              value={AdvisorForm.password}
              onChange={(e) =>
  setAdvisorForm({
    ...AdvisorForm,
    password: e.target.value.slice(0, 8),
  })
}
            />

            {formErrors.password && (
              <span className="form-error">{formErrors.password}</span>
            )}

            <select onChange={(e) => setAdvisorForm({ ...AdvisorForm, userType: e.target.value })}>
              <option selected value="Select Advisor">Select Advisor</option>
              <option value="advisor-district-coordinator">District Coordinator</option>
              <option value="advisor-commisionerate">Commisioner Manager</option>
              <option value="advisor-state-head">State Head</option>

            </select>

            {formErrors.userType && (
              <span className="form-error">{formErrors.userType}</span>
            )}

            {createUserError && (
              <p className='error-msg'>{createUserError}</p>
            )}

            <button
              onClick={async () => {
                const success = await handleCreateUser({
                  ...AdvisorForm

                });

                if (success) {
                  setAdvisorForm(initialAdvisorForm);
                  setShowAddAdvisorModal(false)
                }
              }}
            >
              Done
            </button>
          </div>
        </div>
      )}

      {showAddInfluencerModal && (
        <div className="modal-overlay">
          <div className="modal-content" ref={influencerModalRef}>
            <h2>Add Influencer</h2>

            <input
              placeholder="Name"
              value={influencerForm.name}
onChange={(e) =>
  setInfluencerForm({
    ...influencerForm,
    name: e.target.value
      .replace(/[^A-Za-z ]/g, "")
      .slice(0, 60),
  })
}
            />
            {formErrors.name && (
              <span className="form-error">{formErrors.name}</span>
            )}

            <input
              placeholder="Email"
              value={influencerForm.email}
              onChange={(e) =>
  setInfluencerForm({
    ...influencerForm,
    email: e.target.value
      .toLowerCase()
      .slice(0, 60),
  })
}
            />
            {formErrors.email && (
              <span className="form-error">{formErrors.email}</span>
            )}

            <input
              placeholder="Mobile"
              value={influencerForm.mobile_number}
             onChange={(e) =>
  setInfluencerForm({
    ...influencerForm,
    mobile_number: e.target.value
      .replace(/\D/g, "")
    .slice(0, 10),
  })
}
            />
            {formErrors.mobile_number && (
              <span className="form-error">{formErrors.mobile_number}</span>
            )}

            <input
              type="password"
              placeholder="Password"
              value={influencerForm.password}
              onChange={(e) =>
  setInfluencerForm({
    ...influencerForm,
    password: e.target.value.slice(0, 8),
  })
}
            />
            {formErrors.password && (
              <span className="form-error">{formErrors.password}</span>
            )}

            {createUserError && (
              <p className='error-msg'>{createUserError}</p>
            )}

            <button
              onClick={async () => {
                const success = await handleCreateUser({
                  ...influencerForm,
                  userType: "influencer"
                });

                if (success) {
                  setInfluencerForm(initialInfluencerForm);
                  setShowAddInfluencerModal(false);
                }
              }}
            >
              Done
            </button>
          </div>
        </div>
      )}

      {showDeleteModal && deleteItem && (
        <div
          className="modal-overlay"
          onClick={(e) => {
            if (e.target.classList.contains("modal-overlay")) {
              setShowDeleteModal(false);
              setDeleteItem(null);
            }
          }}
        >
          <div className="modal-content md-content-2 delete-modal">
            <h3>Delete Confirmation</h3>
            <p>Are you sure you want to delete <strong>{deleteItem.name}</strong>?</p>

            {/* Buttons container at bottom right */}
            <div className="delete-modal-footer">
              <button
                className="cancel-btn"
                onClick={() => {
                  setShowDeleteModal(false);
                  setDeleteItem(null);
                }}
              >
                Cancel
              </button>
              <button
  className="delete-btnn"
  onClick={async () => {
    try {
      await api.delete(`/admin/hard-delete/user/${deleteItem._id}`, {
        data: {
          confirmDelete: true,
        },
      });

      toast.success(
        `${activeTab === "vendor"
          ? "Vendor"
          : activeTab === "customer"
          ? "Customer"
          : activeTab === "influencer"
          ? "Influencer"
          : "Advisor"} deleted successfully`
      );

      fetchUsers(1);

    } catch (err) {
      console.error("Delete failed:", err);
      toast.error(err?.response?.data?.message || "Delete failed");
    } finally {
      setDeleteItem(null);
      setShowDeleteModal(false);
    }
  }}
>
  Delete
</button>
            </div>
          </div>
        </div>
      )}

      {/* Edit Modal */}
      {showEditModal && selectedItem && (
        <div
          className="modal-overlay"
          onClick={(e) => {
            if (e.target.classList.contains("modal-overlay")) {
              setShowEditModal(false);
              setSelectedItem(null);
              setEditForm({});
            }
          }}
        >
          <div className="modal-content">
           <h2>
  Edit {activeTab === 'vendor' ? 'Vendor' : activeTab === 'customer' ? 'Customer' : activeTab === 'influencer' ? 'Influencer' : 'Advisor'}
</h2>

            <input
              placeholder="Name"
              value={editForm.name || ''}
             onChange={(e) =>
  setEditForm({
    ...editForm,
    name: e.target.value
      .replace(/[^A-Za-z ]/g, "")
      .slice(0, 60),
  })
}
            />
            {formErrors.name && <span className="form-error">{formErrors.name}</span>}
            <input
              placeholder="Email"
              value={editForm.email || ''}
             onChange={(e) =>
  setEditForm({
    ...editForm,
    email: e.target.value
      .toLowerCase()
      .slice(0, 60),
  })
}
            />
            {formErrors.email && <span className="form-error">{formErrors.email}</span>}
            <input
              placeholder="Mobile"
              value={editForm.mobile_number || ''}
             onChange={(e) =>
  setEditForm({
    ...editForm,
    mobile_number: e.target.value
      .replace(/\D/g, "")
      .slice(0, 8),
  })
}
            />
            {formErrors.mobile_number && (
              <span className="form-error">{formErrors.mobile_number}</span>
            )}
    <select
  value={editForm.gender || ""}
  onChange={(e) =>
    setEditForm({
      ...editForm,
      gender: e.target.value,
    })
  }
>
  <option value="">Select Gender</option>
  <option value="Male">Male</option>
  <option value="Female">Female</option>
  <option value="Other">Other</option>
</select>

{/* Shop Name / Shop Email are vendor-only fields — set during vendor
    onboarding (see vendorOnboard.controller.js) and used for a vendor's
    business listing/search/invoices. Customers, influencers and advisors
    never have a shop, so only show these when editing a vendor. */}
{activeTab === 'vendor' && (
  <>
    <input
      placeholder="Shop Name"
      value={editForm.shop_name || ""}
      onChange={(e) =>
        setEditForm({
          ...editForm,
          shop_name: e.target.value,
        })
      }
    />

    <input
      placeholder="Shop Email"
      value={editForm.shop_email || ""}
      onChange={(e) =>
        setEditForm({
          ...editForm,
          shop_email: e.target.value,
        })
      }
    />
  </>
)}

<textarea
  placeholder="About"
  value={editForm.about || ""}
  onChange={(e) =>
    setEditForm({
      ...editForm,
      about: e.target.value,
    })
  }
/>
<div className="info-field">
  <label>Roles</label>

  <p>
    {editForm.roles?.length
      ? editForm.roles
          .map(
            (role) =>
              `${role.userType} (${role.priority})`
          )
          .join(", ")
      : "No Roles"}
  </p>
</div>
<div className="info-field">
  <label>Services</label>

  <p>
    {editForm.servicesOffered?.length
      ? editForm.servicesOffered.join(", ")
      : "No service added yet"}
  </p>
</div>
            {/* <input
              type="password"
              placeholder="Password (leave blank to keep same)"
              value={editForm.password || ''}
              onChange={(e) => setEditForm({ ...editForm, password: e.target.value })}
            /> */}

            {/* <p className='error-msg'> {createUserError && (
              <p className='error-msg'>{createUserError}</p>
            )}</p> */}
            <div className="form-actions">
              <button
                type="button"
                onClick={() => {
                  setShowEditModal(false);
                  setSelectedItem(null);
                  setEditForm({});
                }}
              >
                Cancel
              </button>

              <button
                type="button"
                onClick={async () => {
                  const errors = validateUserForm(editForm, true, selectedItem);

                  if (Object.keys(errors).length > 0) {
                    setFormErrors(errors);
                    return;
                  }

                  try {
                    const payload = { ...editForm };
                    if (!payload.password) delete payload.password;

                    await api.put(`/admin/update/user/${selectedItem._id}`, payload);

                    toast.success(
                      `${activeTab === "vendor" ? "Vendor" : activeTab === "customer" ? "Customer" : activeTab === "influencer" ? "Influencer" : "Advisor"} updated successfully`
                    );

                    setFormErrors({});
                    fetchUsers(1);
                    setShowEditModal(false);
                    setSelectedItem(null);
                    setEditForm({});
                  } catch (err) {
                    if (err?.response?.status === 409) {
                      setFormErrors({
                        email: "Email already exists",
                      });
                    }
                  }
                }}

              >
                Update
              </button>
            </div>
          </div>
        </div>
      )}


      <ToastContainer
        toastClassName="custom-toast"
        position="top-right"
        autoClose={3000}
        hideProgressBar={false}
        newestOnTop={false}
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover
      />



    </div>
  );
}



export default UserManagement;